import { A11yModule } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, Component, inject, input, type ElementRef, type TemplateRef } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { UserService } from '@big-direkt/state/user';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { EnvironmentService } from '@big-direkt/utils/environment';
import { IconBigMediumLogin, IconComponent } from '@big-direkt/utils/icons';
import { BreakpointService } from '@big-direkt/utils/shared';
import { translateSignal } from '@jsverse/transloco';
import { PopoverService } from '../../services/popover.service';
import { NavUserComponent } from './nav-user.component';

@Component({
    selector: 'big-nav-user-button',
    templateUrl: './nav-user-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [UiButtonComponent, NavUserComponent, A11yModule, IconComponent],
})
export class NavUserButtonComponent {
    public readonly popoverService = inject(PopoverService);
    protected readonly breakpointService = inject(BreakpointService);
    private readonly router = inject(Router);
    private readonly userService = inject(UserService);
    private readonly environmentService = inject(EnvironmentService);

    public readonly iconLogin = IconBigMediumLogin;
    public readonly loggedInTranslation = translateSignal('nav.logged-in');
    public readonly userProfile = toSignal(this.userService.getProfile());

    public readonly isLoggedIn = input.required<boolean>();
    public readonly loggedInText = input.required<string>();
    public readonly loggedOutText = input.required<string>();

    public onUserMenuButtonClick(origin: HTMLElement, content: TemplateRef<ElementRef>): void {
        const isLoggedIn = this.isLoggedIn();

        if (isLoggedIn) {
            this.popoverService.open(content, origin);

            return;
        }

        void this.router.navigateByUrl(this.userService.getLoginUrl(this.environmentService.privatePath));
    }
}
